import { Theme, createStyles } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { borderRadiusButton } from 'components/AppTheme/index';
import { EdwardColors } from 'enums/index';

interface StyleProps {
  fontSize?: string;
}

const useStyles = makeStyles<Theme, Partial<StyleProps>>((theme: Theme) =>
  createStyles({
    root: {
      background: 'transparent',
      display: 'flex',
      alignItems: 'stretch',
      borderRight: 'none',
      [theme.breakpoints.up('sm')]: {
        marginRight: theme.spacing(4),
      },
    },
    item: {
      background: theme.palette.grey['200'],
      '&:hover': {
        background: theme.palette.grey['200'],
      },
      borderRadius: borderRadiusButton,
      '& .MuiTypography-root': { fontWeight: 900 },
      color: '#818284',
      textAlign: 'center',
      display: 'inline-flex',
      marginRight: theme.spacing(1),
      paddingLeft: 0,
      paddingRight: 0,
      '&:last-child': { marginRight: 0 },
      '& .MuiTypography-body1': {
        fontSize: (props) => props?.fontSize || '100%',
      },
      [theme.breakpoints.down('md')]: {
        '& .MuiTypography-body1': {
          fontSize: '80%',
        },
      },
    },
    selected: {
      backgroundColor: EdwardColors.LIGHT,
      color: theme.palette.common.black,
      '&:hover': {
        backgroundColor: EdwardColors.LIGHT,
        color: theme.palette.common.black,
      },
    },
    icon: {
      minWidth: '32px',
      maxWidth: '1em',
      //maxHeight: '1em',
      paddingLeft: theme.spacing(1),
      '& .MuiSvgIcon-root': {
        fontSize: '2em',
      },
    },
    drop: {
      color: '#000',
      '& .MuiListItemText-root': {
        marginLeft: '-32px',
        [theme.breakpoints.down('sm')]: {
          '& .MuiTypography-body1': {
            fontSize: '100%',
          },
        },
      },
    },
    primary: {
      fontWeight: 900, // Bold the primary text
      fontSize: (props) => props?.fontSize || '100%',
      [theme.breakpoints.down('md')]: {
        '& .MuiTypography-body1': {
          fontSize: '80%',
        },
      },
    },
  }),
);

export default useStyles;
